/**
 * True when the Desktop runs without its local Environment Service (adapted from T3 Code). The
 * renderer then has no primary Environment: it skips discovering one and only connects to the
 * Environments this device saved. Always false in a browser, which has no desktop bridge.
 */
export function isLocalEnvironmentDisabled(): boolean {
  return (
    typeof window !== "undefined" && window.desktopBridge?.getLocalEnvironmentEnabled?.() === false
  );
}
